// TODO: https://griosf.atlassian.net/browse/RVLS-7906
const allAccessStrings: string[] = [
  "See what your rivals are saying about your team with read-only access to <b>ALL 100+ forums</b> across the network!",
  "Witness their reaction to commits to [subSchool], games, breaking news, and more",
  "Get the edge in FanFutureCast by knowing what your rivals are thinking",
  "Experience the Rivals network and community virtually ad-free!"
];

// TODO: https://griosf.atlassian.net/browse/RVLS-7906
const learnMoreStrings: string[] = [
  "Ad-Lite eliminates almost all ads across the entire network, giving you a more focused experience in all articles and communities"
];

// TODO: https://griosf.atlassian.net/browse/RVLS-7906
const spyOnRivalStrings: string[] = [
  "Eavesdrop on [rivalSchool] fans with read-only access to their community, and see what they're saying about [subSchool]",
  "Witness their reaction to commits to [subSchool], games, breaking news, and more",
  "Get the edge in FanFutureCast by knowing what your rivals are thinking"
];

// TODO: https://griosf.atlassian.net/browse/RVLS-7906
/* eslint-disable @typescript-eslint/naming-convention */
const addOnTypeLegal: { [key: string]: string[] } = {
  "AD_LITE AD_LITE": learnMoreStrings,
  "ALL_ACCESS ALL_ACCESS": allAccessStrings,
  "SPY SPY": spyOnRivalStrings
};
/* eslint-enable @typescript-eslint/naming-convention */

// TODO: https://griosf.atlassian.net/browse/RVLS-7906
export default {
  add: "Add", // duplicate
  billedAsPart: "Billed as part of your [subSchool] subscription",
  details: "Add-on details",
  learnMore: addOnTypeLegal
};
